import { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { Toaster } from '@/components/ui/sonner';
import { router } from './routes';
import DelayedProviders from '@/components/DelayedProviders';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import PreferredLanguageSync from '@/components/Translation/PreferredLanguageSync';
import PageLoadingSkeleton from '@/components/PageLoadingSkeleton';

// Create a client
const queryClient = new QueryClient();

function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <DelayedProviders>
          <Suspense fallback={<PageLoadingSkeleton />}>
            <RouterProvider router={router} />
          </Suspense>
          <PreferredLanguageSync />
          <Toaster position="top-right" richColors />
        </DelayedProviders>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
